export default __webpack_public_path__ + "static/LUXCE LAMINATE-b9d1b167f2d1c3f8f9ac81eba1bd0cb0.webp";